exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".quc-wrapper .quc-tip-absolute {\n  top: 0 !important; }\n\n.quc-wrapper .quc-input .quc-input-append {\n  border-left: 0 !important;\n  background: none !important; }\n", ""]);

// exports
